import { useCallback, useEffect, useState } from 'react';

import { RemovalChronicDiseaseModal, RemovalChronicDiseaseModalSubmitHandler } from './RemovalChronicDiseaseModal';
import { registerShowRemovalChronicDiseaseModalEventListener } from './RemovalChronicDiseaseModal.event';
import { ChronicDiseaseRemovalState } from './RemovalChronicDiseaseModal.types';

export type RemovalChronicDiseaseRevertEventHandler = (chronicDisease: ChronicDiseaseRemovalState) => void;

type RemovalChronicDiseaseModalEventListenerProps = {
   readonly visitBeginDate: Date;
};

export const RemovalChronicDiseaseModalEventListener = (
   props: RemovalChronicDiseaseModalEventListenerProps
): JSX.Element | null => {
   const [state, setState] = useState<ChronicDiseaseRemovalState | null>(null);

   const clearRemovalChronicDisease = useCallback((): void => {
      setState(null);
   }, [setState]);

   const handleClose = useCallback(() => {
      state?.onCancel();
      clearRemovalChronicDisease();
   }, [state, clearRemovalChronicDisease]);

   const handleSubmit = useCallback<RemovalChronicDiseaseModalSubmitHandler>(
      (parameters) => {
         state?.onSubmit(parameters);
         clearRemovalChronicDisease();
      },
      [clearRemovalChronicDisease, state]
   );

   useEffect(
      () =>
         registerShowRemovalChronicDiseaseModalEventListener((event) => {
            setState(event.detail);
         }),
      []
   );

   if (!state) {
      return null;
   }

   return (
      <RemovalChronicDiseaseModal
         onClose={handleClose}
         onSubmit={handleSubmit}
         chronicDiseaseToRemoval={state}
         visitBeginDate={props.visitBeginDate}
      />
   );
};
